import PropTypes from 'prop-types';
import React from 'react';

import { Job } from 'join-us/components/Job';

export const Department = ({ department }) => {
  const { jobs } = department;

  return (
    jobs.length > 0 && (
      <div className="JobBoard__department">
        <div className="new-h6 uppercase JobBoard__department-name">
          {department.name}
        </div>
        <div className="JobBoard__department-jobs">
          {jobs.map(job => (
            <Job key={job.id} department={department} job={job} />
          ))}
        </div>
      </div>
    )
  );
};

Department.propTypes = {
  department: PropTypes.object.isRequired,
};
